import { showSuccess } from '@/commons/show-success.ts';
import { type SuccessTip } from '@ts-max/axios';
import { type AxiosResponse } from 'axios';
import { isValidElement, type ReactNode } from 'react';

export function handleSuccess(
  options: AxiosResponse | SuccessTip | string | ReactNode,
) {
  let successTip: boolean | string | ReactNode | SuccessTip;

  if (isAxiosResponse(options)) {
    const { config } = options;
    if (!config) return;

    successTip = config.successTip ?? false;
    if (!successTip) return;

    // 后端message作为提示内容
    if (successTip === true) {
      successTip = options?.data?.message;
    }
  } else {
    successTip = options;
  }

  showSuccess(successTip);
}

/**
 * 判断是否为AxiosResponse
 * @param response
 */
function isAxiosResponse(
  response: AxiosResponse | SuccessTip | string | ReactNode,
): response is AxiosResponse {
  return (
    typeof response === 'object' &&
    response !== null &&
    !isValidElement(response) &&
    'config' in response
  );
}
